import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;
const ACCOUNTS = 'accounts/recordCashout';

export default class CashoutService {
    static async create(requestBody) {
        const result = await ApiService.PostData(ACCOUNTS, requestBody, API_URLS.ACCOUNTS);
        return result;
    }
}